import { createRootComponent } from '../utils/create-root-component'

import { AccountValuePropApp } from '@/apps/account-value-prop-app'

export default createRootComponent('account-value-prop', AccountValuePropApp)
